import type { HeadingProps } from '@chakra-ui/react'
import { Heading } from '@chakra-ui/react'

export type SectionHeadingProps = HeadingProps

export const SectionHeading = (props: SectionHeadingProps) => {
  return (
    <Heading
      sx={{ fontSize: 'lg', fontWeight: 'bold', width: '100%', ...props.sx }}
    >
      {props.children}
    </Heading>
  )
}
